export default __webpack_public_path__ + "static/media/Explore-2-mini.ea808135.png";